import React, { FC, useEffect, useState } from 'react';

import Table from '~components/molecules/Table';

import { useAppDispatch, useAppSelector } from '~redux/hooks';

import * as Styles from './CustomerManagementConversionTable.module.scss';
import ViewSerialNoModalModal from '~components/molecules/ViewSerialNoModal';
import ActionButton from '~components/atoms/ActionButton';
import UtilFunctions from '~utils/functions';
import { ModuleEnum, PermissionsEnum, TransactionStatusEnum } from '~utils/enums';
import Chip from '~components/atoms/Chip';
import combinedActions from '~redux/combinedActions';
import Text from '~components/atoms/Text';
import Pagination from '~components/atoms/Pagination';

const CustomerManagementConversionTable = () => {
    const dispatch = useAppDispatch();
    const { Misc: { dateTimeFormat } } = UtilFunctions;

    const isLoading = useAppSelector(state => state.customer.loadings.getCustomerConversion);
    const { index, maxIndex, data: customerConversion } = useAppSelector(state => state.customer.customerConversion);
    const customerId = useAppSelector(state => state.customer.customerDetails.customerId);

    const [serialNoList, setSerialNoList] = useState<string[]>([]);
    const [isSerialNoModalOpen, setIsSerialNoModalOpen] = useState(false);

    useEffect(() => {
        dispatch(combinedActions.customerGetCustomerConversionListingAttempt({ id: customerId }));
    }, [customerId]);

    const setIndex = (idx: number) => dispatch(combinedActions.customerSetCustomerConversionIndex({ index: idx }));

    useEffect(() => {
        dispatch(combinedActions.customerGetCustomerConversionListingAttempt({ id: customerId }));
    }, [customerId, index]);

    // if maxIndex is lower then index reset index to 0
    useEffect(() => {
        if (index > maxIndex) {
            setIndex(0);
        }
    }, [maxIndex]);

    const handleOnPrev = () => {
        if (index > 0) setIndex(index - 1);
    };
    const handleOnNext = () => {
        if (index < maxIndex) setIndex(index + 1);
    };
    const handleOnFirst = () => setIndex(0);
    const handleOnLast = () => setIndex(maxIndex >= 0 ? maxIndex : 0);

    const tableHeader = [
        'TRANSACTION ID',
        'AMOUNT',
        'PRODUCT CONVERTED',
        'CONVERSION FEE',
        'SERIAL NUMBER',
        'BRANCH CODE',
        'BRANCH NAME',
        'REGION NAME',
        'STATUS',
        'BRANCH TELLER NAME',
        'SALES PERSONNEL NAME',
        'REFERRAL NAME',
        'TRANSACTION DATE',
        // 'ACTION',
    ];

    const tableBody = customerConversion.map(conversion => {
        const {
            conversionId,
            amount,
            targetProductName,
            serialNo,
            branchCode,
            branchName,
            regionName,
            status,
            conversionFee,
            branchTellerName,
            salesPersonnelName,
            referralName,
            createdAt,
            metalType,
        } = conversion;

        const handleViewSerialNo = () => {
            if (!serialNo) return;

            setIsSerialNoModalOpen(true);
            setSerialNoList(serialNo);
        };

        const renderSerialNo = () => {
            if (!serialNo) return '-';

            return (
                <ActionButton
                    testId='create-conversion-view-serialNo-modal-button'
                    key={conversionId}
                    label='View'
                    onClick={() => handleViewSerialNo()}
                />
            );
        };

        const renderStatusChip = (statusValue: TransactionStatusEnum, label: string) => {
            switch (statusValue) {
                case TransactionStatusEnum.Pending: {
                    return (
                        <Chip
                            type='warning'
                            label={label}
                        />
                    );
                }

                case TransactionStatusEnum.Approved: {
                    return (
                        <Chip
                            type='success'
                            label={label}
                        />
                    );
                }

                case TransactionStatusEnum.Rejected: {
                    return (
                        <Chip
                            type='error'
                            label={label}
                        />
                    );
                }

                default: return <Chip label={label} />;
            }
        };

        return {
            // className: Number(metalType) === MetalTypeEnum.Gold
            //     ? Styles['gold-row']
            //     : '',
            cells: [
                conversionId,
                amount,
                targetProductName,
                conversionFee.toFixed(2),
                renderSerialNo(),
                branchCode,
                branchName,
                regionName,
                renderStatusChip(status, TransactionStatusEnum[status]),
                branchTellerName || '-',
                salesPersonnelName || '-',
                referralName || '-',
                dateTimeFormat(createdAt),
                // (
                //     <div key={`action-${conversionId}`} className={Styles['action-button-container']}>
                //         <div>
                //             <ActionButton
                //                 label='View Details'
                //                 onClick={() => handleViewTransaction(conversion)}
                //             />
                //         </div>
                //     </div>
                // ),
            ],
        };
    });

    return (
        <>
            <Text
                label='Customer Conversions'
                isBold
            />

            <Table
                header={tableHeader}
                body={tableBody}
                isLoading={isLoading}           
            />

            <Pagination
                currentPage={index}
                maxPage={maxIndex}
                onPrev={handleOnPrev}
                onNext={handleOnNext}
                onFirst={handleOnFirst}
                onLast={handleOnLast}
            />

            <ViewSerialNoModalModal
                isOpen={isSerialNoModalOpen}
                onClose={() => setIsSerialNoModalOpen(false)}
                serialNo={serialNoList}
            />

        </>

    );
};

export default CustomerManagementConversionTable;
